import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../../components/common/faq";

const faqs = [
  {
    question: "How Much to Charge for Website Development in Saudi Arabia?",
    answer: `<p>Based on business requirements, a good website may cost around 1,000 SAR to 20,000 SAR. The ideal way to know how much it costs to make a website in Saudi Arabia is to contact the relevant web development companies in the region to have a clear idea.</p>`,
  },
  {
    question: "Which Technology is Best for Website Development in KSA?",
    answer: `<p>Angular is a web development framework created by Google. Despite being around for some time, Angular continues to be a popular choice among web developers. However, some other frameworks like React JS and Laravel have been impactful when it comes to the development of complex websites.</p>`,
  },
  {
    question: "What is the Best Programming Language for Website Development?",
    answer: `<p>Although there are multiple languages to develop a website. However, here’s the list of the best web programming languages that have been widely used globally:</p>
        <ul>
                 <li>JavaScript</li>
                 <li>Java</li>
                 <li>HTML</li>
                 <li>CSS</li>
                 <li>React</li>
                 <li>Angular</li>
                 <li>Objective C</li>
             </ul> 
        `,
  },
  {
    question: "What is the Difference Between Website Design and Development?",
    answer: `<p>Web designers craft a website's look and feel, and web developers develop the code to make it functional.</p>
        <p>Website designers and developers frequently collaborate, although their roles differ. As a result, websites play a significant role in various aspects of our daily lives, facilitating diverse functionalities and services.</p>`,
  },
  {
    question: "What are the Programming Languages Used in Web Development?",
    answer: `<p>Several commonly used programming languages for web development include HTML/CSS, PHP, Python, JavaScript, Java, Ruby, and Swift. However, this list is not comprehensive, and numerous other options are available as needed.</p> `,
  },
  {
    question: "What are the Programming Languages Used in Web Development?",
    answer: `<p>Following are the steps that you must consider while choosing a web development company:</p>
    <ul>
    <li>Define your objectives for web development clearly</li>
    <li>Identify potential partners for web development</li>
    <li>Assess their experience and expertise in the field</li>
    <li>Review their previous projects and portfolios</li>
    <li>Take into account testimonials and reviews from other clients</li>
    <li>Emphasize the importance of transparent communication</li>
    <li>Establish a project timeline</li>
    <li>Evaluate the technology tools and team composition</li>
    <li>Consider the project budget carefully</li>
    <li>Assess the level of support and maintenance provided</li>
    </ul> `,
  },
  {
    question: "Why Choose TekRevol for Web Development in KSA?",
    answer: `<p>You can consider TekRevol for web development in KSA as we have proven experience in creating different scales of web solutions designed to meet your unique requirements. Our team of experts prioritizes quality with innovation. That’s why we guarantee that your web development project is entrusted to skilled professionals. As a result, we can easily deliver exceptional outcomes that help your business grow.</p> `,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
          {/* <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
            <div className="map_loc">{DubaiPin}</div>
          </Col> */}
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
